import { render, staticRenderFns } from "./waitAdmit.vue?vue&type=template&id=19ed8298"
import script from "./waitAdmit.vue?vue&type=script&lang=js"
export * from "./waitAdmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports